import { Note } from "common";
import { useNoteYouthKid } from "./useNoteYouthKid";

export const useNoteYouthKidName = (note: Note) => {
  const youthKid = useNoteYouthKid(note);
  if (youthKid) {
    return `${youthKid.fName} ${youthKid.lName}`;
  }
  return `Deleted Youth Kid`;
};
